export default __webpack_public_path__ + "static/media/thurs-blue.3dbf35f9.png";